module.exports = __webpack_public_path__ + "img/user-4-line.74ff3e60.svg";